<template>
  <span>
    <el-popover placement="bottom-end" title="" width="250" :visible="isVisible">
      <!-- <div class="filter-cell-control" v-click-outside="onClickOutside"> -->
      <div class="filter-cell-control" >
        <base-input  v-if="inputType == 'date'" class="range-picker">
          <el-date-picker type="daterange" @change="updateModel" v-model="val" value-format="YYYY-MM-DD"
            format="DD/MM/YYYY">
          </el-date-picker>
        </base-input>
        <el-input v-else v-model="val" :clearable="true" @input="updateModel"></el-input>

        <div style="padding-top: 5px">
          <el-button type="primary" size="small" @click="search">confirm</el-button>
          <el-button type="primary" size="small" @click="onClose">close</el-button>
        </div>
      </div>
      <template #reference>
        <el-button link type="text" @click="onClick" v-if="filterKey" class="filter-button">
          <el-icon :size="18" style="color: var(--el-text-color-primary)">
            <Search class="filter-button-svg" />
          </el-icon>
        </el-button>
      </template>
    </el-popover>
  </span>
</template>

<script setup>
import { ref, watch } from 'vue';
import { Search } from '@element-plus/icons-vue';
import { ClickOutside as vClickOutside } from '@/assets/js/directive';
import baseInput from '@/components/newUI/Inputs/BaseInput';

const val = ref();
const isVisible = ref(false);
const props = defineProps({
  prop: {
    type: String,
    default: 'prop',
  },
  modelValue: {
    type: String,
    default: '',
    descritpion: '绑定的值',
  },
  filterKey: {
    type: String,
    default: '',
    descritpion: '绑定的Key',
  },
  visible: {
    type: Boolean,
    default: false,
    descritpion: '是否可见搜索',
  },
  virtualTriggering: {
    type: Boolean,
    default: false,
    descritpion: '是否开启虚拟触发',
  },
  inputType: {
    type: String,
    default: 'input',
    descritpion: '组件类型',
  },
});

const emit = defineEmits(['confirm', 'click', 'close', 'update:modelValue']);
const search = () => {
  onClose();
  emit('confirm');
};

const onClick = () => {
  isVisible.value = !isVisible.value;
  emit('click', props.filterKey);
};

const onClose = () => {
  isVisible.value = false;
  emit('close');
};

const updateModel = (value) => {
  emit('update:modelValue', value);
};

const onClickOutside = (e) => {
  if (isVisible.value) {
    console.log('e', e, isVisible.value, props.virtualTriggering);
    if (props.virtualTriggering) {
      if (e.target.attributes?.class?.value?.includes('filter-button')) {
        return;
      }
      if (e.target.attributes?.class?.value?.includes('el-popper')) {
        return;
      }
      onClose();
    }
  }
};

defineExpose({
  close: onClose,
});
watch(
  () => props.modelValue,
  (newValue) => {
    val.value = newValue;
  },
  {
    immediate: true,
  }
);
watch(
  () => props.visible,
  (newValue) => {
    isVisible.value = newValue;
  },
  {
    immediate: true,
  }
);
</script>
<style>
.el-table .cell {
  white-space: pre-line !important;
}

.filter-cell-control {
  min-width: 230px;
}
</style>
